import React from 'react';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';

import CommonEmailForm from './CommonEmailForm';

class PartsNameEmailForm extends React.Component {
  static propTypes = {
    userName: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    carLocation: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    changeHandler: PropTypes.func.isRequired,
    onSubmitHandler: PropTypes.func.isRequired,
    disableBtnLeasing: PropTypes.bool,
    advert: PropTypes.shape.isRequired,
  };

  static defaultProps = {
    disableBtnLeasing: false,
  };

  handleOptionChange = event => {
    event.stopPropagation();
    if (this.props.changeHandler instanceof Function) {
      this.props.changeHandler('carLocation', event.target.value);
    }
  };

  render() {
    const { t, advert } = this.props;

    const title = t('Наши партнеры помогут Вам подобрать запчасти {title} по Вашим параметрам.', {
      title: advert.title,
    });
    const subTitle = t('0% комиссии с нашей стороны.');
    const fillFormText = t('Чтобы отправить запрос – заполните, пожалуйста, форму ниже:');
    const footerTitle = t(
      'Мы можем передать Ваш запрос как на подбор {title} находящихся в Украине так и под Ваш заказ из-за рубежа.',
      { title: advert.title },
    );
    const footerText = t(
      'Мы работаем только с проверенными партнерами, и уверены, что Вы будете удовлетворены результатом.',
    );
    return (
      <CommonEmailForm
        title={title}
        subTitle={subTitle}
        fillFormText={fillFormText}
        footerTitle={footerTitle}
        footerText={footerText}
        disabledBtn={this.props.disableBtnLeasing}
        userName={this.props.userName}
        phone={this.props.phone}
        carLocation={this.props.carLocation}
        errorMessage={this.props.errorMessage}
        successMessage={this.props.successMessage}
        changeHandler={this.props.changeHandler}
        onSubmitHandler={this.props.onSubmitHandler}
      />
    );
  }
}

export default withTranslate(PartsNameEmailForm);



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestForm/PartsNameEmailForm.js